import { PermissionType } from 'enums/permissionType.enum';
import { PageURL } from 'router/pageURL';
import { IHeaderMenuItem } from './types';

export const headerTabsOptions: IHeaderMenuItem[] = [
  {
    textId: 'menu.applications',
    link: PageURL.APPLICATIONS,
    permissions: [PermissionType.ADMIN, PermissionType.BROKER, PermissionType.ANALYST],
  },
  {
    textId: 'menu.products',
    link: PageURL.PRODUCTS,
    permissions: [PermissionType.ADMIN, PermissionType.UNDERWRITER, PermissionType.ANALYST, PermissionType.FINANCE],
  },
];
